import React, { useState } from "react";
import { Hero, TeamMember } from "../../components";
import teamMembersData from "./data";

function Team() {
  const [openMember, setOpenMember] = useState<string | null>(
    "Jacqueline Gauthier"
  );

  const handleTeamMemberClick = (index: string) => {
    if (openMember === index) {
      // Clicked on the already open TeamMember, so close it
      setOpenMember(null);
    } else {
      // Clicked on a different TeamMember, so open it
      setOpenMember(index);
    }
  };

  // Créer des lignes de 3 membres d'équipe chacune
  const rows = [];
  for (let i = 0; i < teamMembersData.length; i += 3) {
    const rowMembers = teamMembersData.slice(i, i + 3);
    rows.push(rowMembers);
  }

  return (
    <div className="flex overflow-x-hidden overflow-y-hidden relative flex-col -z-10">
      <Hero title={"Team"}>
        "Talent wins games, but teamwork and intelligence{" "}
        <span className="text-lg font-black text-RougePastel md:text-xl lg:text-2xl">
          win championships.
        </span>{" "}
        ." - Michael Jordan
      </Hero>

      <div className="flex w-full px-[24px] md:px-[70px] py-[50px] justify-center items-center">
        <div
          className="flex justify-center items-center mx-auto flex-col md:max-w-[1500px] gap-[30px]"
          id="page-content"
        >
          <div className="grid grid-cols-1 md:grid-cols-2  lg:grid-cols-4 py-[50px] md:max-w-[1500px] lg:gap-10 gap-8">
            {teamMembersData.map((member: any, index: any) => (
              <TeamMember
                key={index}
                {...member}
                isOpen={openMember === member.name}
                onClick={() => handleTeamMemberClick(member.name)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Team;
